import React from "react";
import "./iconsAnimation.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faKeyboard,
//   faCodeBranch,
//   faMicrochip,
//   faTerminal,
//   faFolderOpen,
//   faBatteryHalf,
//   faCoffee,
//   faBug,
//   faBolt,
//   faFileAlt,
//   faQrcode,
//   faComments,
//   faEnvelope,
//   faProjectDiagram,
//   faUserSecret,
//   faGlobe,
//   faWindowMaximize,
//   faShieldAlt,
//   faSitemap,
//   faCode,
//   faPowerOff,
//   faServer,
//   faPlug,
//   faHdd,
//   faDesktop,
//   faDatabase,
//   faPrint,
//   faUpload,
//   faCropAlt,
//   faLayerGroup,
//   faUser,
//   faToggleOn,
//   faWifi,
//   faStar,
//   faFolderPlus,
//   faDiceD6,
//   faLock,
//   faSdCard,
//   faUserCircle,
//   faShareAlt,
// } from "@fortawesome/free-solid-svg-icons";
import {
  SiAmazonaws,
  SiAngular,
  SiBootstrap,
  SiCloudflare,
  SiCodepen,
  SiCss3,
  SiDart,
  SiDigitalocean,
  SiDocker,
  SiElasticsearch,
  SiExpress,
  SiFigma,
  SiFirebase,
  SiFlutter,
  SiGatsby,
  SiGit,
  SiGithub,
  SiGnubash,
  SiGoogle,
  SiGooglecloud,
  SiGrafana,
  SiGraphql,
  SiHasura,
  SiHtml5,
  SiJavascript,
  SiJenkins,
  SiJest,
  SiKalilinux,
  SiKubernetes,
  SiLinux,
  SiMongodb,
  SiMui,
  SiMysql,
  SiNetlify,
  SiNextdotjs,
  SiNginx,
  SiNodedotjs,
  SiNpm,
  SiOpenai,
  SiOwasp,
  SiPostgresql,
  SiPostman,
  SiPowershell,
  SiPython,
  SiReact,
  SiRedis,
  SiRust,
  SiSass,
  SiSketch,
  SiSlack,
  SiStackoverflow,
  SiSvelte,
  SiSwift,
  SiTailwindcss,
  SiTerraform,
  SiTypescript,
  SiUdemy,
  SiVercel,
  SiVisualstudiocode,
  SiVuedotjs,
  SiWindows
} from "react-icons/si";
class IconsAnimation extends React.Component {
  constructor(props) {
    super(props);
    this.lineNumber = 0;
    this.sectionRef = React.createRef();
    this.observer = null;
  }
  componentDidMount() {
    this.lineNumber = 6; 
    this.forceUpdate();

    // Pause animations when scrolled out of view to save CPU
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (this.sectionRef.current) {
          if (entry.isIntersecting) {
            this.sectionRef.current.classList.remove('paused');
          } else {
            this.sectionRef.current.classList.add('paused');
          }
        }
      },
      { threshold: 0 }
    );
    if (this.sectionRef.current) {
      this.observer.observe(this.sectionRef.current);
    }
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  render = () => {
    const Icon = ({ component: Component, ...props }) => {
      if (!Component) return null;
      return <Component {...props} />;
    };

    const icons = [
      SiReact, SiAngular, SiNextdotjs, SiNodedotjs, SiExpress,
      SiMysql, SiMongodb, SiHtml5, SiCss3, SiJavascript,
      SiTypescript, SiGithub, SiGit, SiDocker, SiKalilinux,
      SiLinux, SiWindows, SiGnubash, SiPowershell, SiOwasp,
      SiNetlify, SiVercel, SiFirebase, SiAmazonaws, SiGoogle,
      SiOpenai, SiVisualstudiocode, SiPostman,
      SiBootstrap, SiGatsby, SiGraphql, SiHasura, SiMui,
      SiNpm, SiSass, SiSketch, SiSlack, SiStackoverflow,
      SiSwift, SiUdemy, SiCodepen,
      SiPython, SiRust, SiKubernetes, SiTerraform, SiJenkins,
      SiNginx, SiRedis, SiPostgresql, SiElasticsearch, SiFigma,
      SiVuedotjs, SiSvelte, SiTailwindcss, SiFlutter, SiDart,
      SiCloudflare, SiDigitalocean, SiGooglecloud, SiGrafana, SiJest
    ];

    // Fisher-Yates shuffle with a simple seed so each row is unique but stable across re-renders
    const shuffle = (arr, seed) => {
      const a = [...arr];
      let s = seed;
      for (let i = a.length - 1; i > 0; i--) {
        s = (s * 16807 + 0) % 2147483647; // LCG pseudo-random
        const j = s % (i + 1);
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    };

    const buildIconGroup = (seed) => {
      const shuffled = shuffle(icons, seed);
      const set = shuffled.map((Ic, idx) => (
        <Icon key={idx} component={Ic} className="icon" size={60} />
      ));
      return (
        <div className="icon-group">
          {set}{set}{set}
        </div>
      );
    };

    const fastest = 25;
    const slowest = 90;
    let topRows = [];
    let bottomRows = [];
    for (let i = 0; i < this.lineNumber; i++) {
      const center = (this.lineNumber - 1) / 2;
      const dist = Math.abs(i - center) / center;
      const offset = (i - center) * 8;
      const duration = fastest + dist * (slowest - fastest) + offset + 's';
      topRows.push(
        <div className="row" key={i}>
          <div className="marquee-track-left" style={{ animationDuration: duration }}>
            {buildIconGroup(i + 1)}
            {buildIconGroup(i + 1)}
          </div>
        </div>
      );
      bottomRows.push(
        <div className="row2" key={i}>
          <div className="marquee-track-right" style={{ animationDuration: duration }}>
            {buildIconGroup(i + 100)}
            {buildIconGroup(i + 100)}
          </div>
        </div>
      );
    }
    return (
      <div id="iconsSection" ref={this.sectionRef}>
        {topRows}
        <div className="midLine" />
        {bottomRows}
      </div>
    );
  };
}

export default IconsAnimation;
